import React from "react";
import { Globe } from "lucide-react";
import { useI18n } from "../i18n";
import { LANG_NAMES } from "../i18n_public";

const LOCALES = ["es", "en", "fr", "pt", "it"];

export function LangSwitcher({ className = "" }) {
  const { locale, setLocale } = useI18n();
  return (
    <div className={`relative inline-flex items-center ${className}`}>
      <Globe size={15} strokeWidth={1.9} className="absolute left-2.5 text-[#5F8588] pointer-events-none" />
      <select
        data-testid="lang-switcher"
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        aria-label="Language / Idioma"
        className="appearance-none h-9 pl-8 pr-7 rounded-md border border-[#D5E7E5] bg-white text-sm text-[#075E62] hover:text-[#0299A0] focus:outline-none focus:ring-2 focus:ring-[#35BBAE]/40 transition-colors duration-150 cursor-pointer"
      >
        {LOCALES.map((l) => (
          <option key={l} value={l}>{LANG_NAMES[l]}</option>
        ))}
      </select>
      <svg className="absolute right-2 pointer-events-none text-[#5F8588]" width="10" height="10" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
    </div>
  );
}
